"use client";
import FeaturedProducts from "@/components/FeaturedProducts";
import type { FeaturedProductsProps } from "@/components/FeaturedProducts/types";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import { DegreeDetailRedesignTestResult } from "@/monarch/rules/degreeDetailRedesignTraffic/types";

type DegreeCurriculumProps = FeaturedProductsProps & {
  title?: string;
};

const DegreeCurriculum = (props: DegreeCurriculumProps) => {
  return (
    <MonarchDataConsumer<DegreeDetailRedesignTestResult>
      experimentKey="useDegreeDetailRedesignTraffic"
      render={({ data }) => {
        const hideCtaTitle =
          data?.curriculumCta?.hide || data?.curriculumCta?.hideTitle;
        const hideCtaButton =
          data?.curriculumCta?.hide || data?.curriculumCta?.hideButton;
        return (
          <div className="bg-putty-100">
            <div className="container w-full bg-putty-100">
              {props.title && <h2>{props.title}</h2>}
              <FeaturedProducts
                {...props}
                ctaLabel={
                  hideCtaButton
                    ? ""
                    : (data?.curriculumCta?.text ?? props.ctaLabel)
                }
                ctaUrl={
                  hideCtaButton
                    ? ""
                    : (data?.curriculumCta?.url ?? props.ctaUrl)
                }
                ctaHeader={
                  hideCtaTitle
                    ? ""
                    : (data?.curriculumCta?.title ?? props.ctaHeader)
                }
              />
            </div>
          </div>
        );
      }}
    />
  );
};

export default DegreeCurriculum;
